/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Less_Lazy_Mammoth_NurtureInputs */

const en_less_lazy_mammoth_nurture = /** @type {(inputs: Less_Lazy_Mammoth_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histogram`)
};

const de_less_lazy_mammoth_nurture = /** @type {(inputs: Less_Lazy_Mammoth_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histogramm`)
};

/**
* | output |
* | --- |
* | "Histogram" |
*
* @param {Less_Lazy_Mammoth_NurtureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const less_lazy_mammoth_nurture = /** @type {((inputs?: Less_Lazy_Mammoth_NurtureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Less_Lazy_Mammoth_NurtureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_less_lazy_mammoth_nurture(inputs)
	return de_less_lazy_mammoth_nurture(inputs)
});